/**
 * SectionDivider — json-render web wrapper (verified P3.4a)
 *
 * Web implementation for the json-render catalog.
 * Visual spec: Sally (Discourse #3543/4) — Section 7
 *
 * Thin wrapper: hr + tailwind. No existing RN component maps to this.
 * Styling verified against app's section separators.
 *
 * Variants:
 *   subtle     — standard 1px border (default)
 *   emphasized — 2px border + accent color (signals premium content follows)
 *
 * Task: [#1158.SDUI-M.P3.4a]
 * Agent: Diego <diego@liftping.net>
 */
"use client";

import React from "react";
import { cn } from "../../lib/utils";
import type { SectionDividerProps } from "../schema";

const variantClasses: Record<"subtle" | "emphasized", string> = {
  subtle: "border-t border-border",
  emphasized: "border-t-2 border-[#C8A882]",
};

const spacingClasses: Record<"sm" | "md" | "lg", string> = {
  sm: "my-2",
  md: "my-4",
  lg: "my-8",
};

export function SectionDivider({
  label,
  variant = "subtle",
  spacing = "md",
}: SectionDividerProps) {
  const hrClass = variantClasses[variant];

  if (!label) {
    return <hr className={cn(hrClass, spacingClasses[spacing])} />;
  }

  return (
    <div className={cn("flex items-center gap-3", spacingClasses[spacing])}>
      <hr className={cn(hrClass, "flex-1")} />
      <span className="text-xs text-muted-foreground uppercase tracking-wide shrink-0">
        {label}
      </span>
      <hr className={cn(hrClass, "flex-1")} />
    </div>
  );
}
